<template>
  <div>
			<div v-for="(catagoryGroup, index) in listData" :key="index">
			<div class="container  mgt-16" v-if="campaignData && parseInt(campaignData.locationValue) === index + 1">
				<a class="d-block" v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
					<img :src="campaignData.image" :alt="campaignData.name" class="b-radius4 survey-banner"/>
				</a>
				<a class="d-block" v-else href="javascript:void(0)" style="cursor:none">
					<img :src="campaignData.image" :alt="campaignData.name" class="b-radius4  survey-banner"/>
				</a>
			</div>
		<div class="container mgt-16" v-if="!!catagoryGroup"  :class=" index!==0 ? 'mgt-60' : ''">
			<div class="d-flex justify-content-between align-items-baseline mgt-16 mgb-16" v-if="!!catagoryGroup && catagoryGroup.surveys.length">
				<div class="t-color-headlineBlack t-headline10 font-b t-line-h-33">{{ catagoryGroup.category.name }}</div>
				<div class="t-body2 t-line-h-22 l-spacing98">
					<router-link tabindex="0"
						v-if="catagoryGroup.surveys.length > 1"
						class="t-color-secondaryBtnText font-m"
						:to="`?listType=category&id=${catagoryGroup.category.id}&name=${catagoryGroup.category.name}`"
						>{{ $t("217") }}
					</router-link>
				</div>
			</div>
		</div>
	<div class="container main-swiper-container" :class=" index!==0 ? 'mgb-50' : ''" v-if="catagoryGroup.surveys.length">
	<swiper :options="swiperOption" ref="mySwiper" class="main-swiper pdx-4" >
		<!-- Additional required wrapper -->
		<!-- <div class="swiper-wrapper" > -->
			<!-- Slides -->
			<swiper-slide class="swiper-slide" v-for="(survey, index2) in catagoryGroup.surveys" :key="index2">
				<div class="mdc-card cursor-pointer"  @click="viewDetail(survey.id)" @keypress="viewDetail(survey.id)" tabindex="0">
					<div class="mdc-card__primary-action" >
						<div class=" position-relative">
							<div class="pdl-24 pdr-24 pdt-24">
								<img :src="survey.image" :alt="survey.name" v-if="survey.image" class="test-carousel-image" />
								<img src="/images/survey/no-carousel-image.png" v-else alt="" class="test-carousel-image" />
							</div>
							<div class="mdc-chip-set swiper-chip test-swiper-chip" role="grid">
								<div class="mdc-chip h-32 t-line-h-initial" role="row">
									<div class="mdc-chip__ripple"></div>
									<span role="gridcell">
										<span role="button" class="mdc-chip__primary-action">
											<span
												class="mdc-chip__text t-body3 pdt-4 pdb-4 t-color-white font-rn"> {{ index2 + 1 }} /
													{{ getCount(catagoryGroup.surveys).length }}</span>
										</span>
									</span>
								</div>
							</div>
						</div>
						<div class="mgt-24 pdb-35">
							<div class="t-headline7 pdl-24 pdr-24 font-m t-line-h-28">
								{{ survey.name }}
							</div>
						</div>
					</div>
				</div>
			</swiper-slide>
			<!-- end slids -->
		<!-- </div> -->
			<div class="swiper-button-prev custom-nav" slot="button-prev">
				<i class="material-icons t-color-iconActive rtl-support">arrow_back</i></div>
			<div class="swiper-button-next  custom-nav" slot="button-next">
				<i class="material-icons t-color-iconActive rtl-support">arrow_forward</i>
			</div>
	</swiper>
		</div>
  </div>
		</div>
</template>

<script>
/**
 * 단독 설문 전체 목록  컴포넌트(independent survey total list - card type component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  props: ["listData", "campaignData"],
  data() {
			return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        translate: 0,
        autoHeight: false,
      },
			};
		},
  components: {
			swiper,
			swiperSlide,
  },
		computed : {
			swiper() {
					return this.$refs.mySwiper.$swiper
			}
		},
  // mounted() {
		// window.mdc.autoInit();
		// if (document.querySelectorAll(".main-swiper")) {
		// 		var mySwiper = new Swiper('.main-swiper', {
		// 		slidesPerView: 3,
		// 		spaceBetween: 22,
		// 		// Navigation arrows
		// 				navigation: {
		// 						nextEl: '.swiper-button-next',
		// 						prevEl: '.swiper-button-prev',
		// 				}
		// 		})
		// }
  // },

  methods: {
	// 상세로 이동(move view)
			viewDetail(id) {
					this.$router.push({
						name: "IndependentSurveyTotalView",
						params: { distId: id },
						query: this.$route.query,
					});
			},
			getCount(surveylist) {
					// console.log("surveylist", surveylist);
					let surveylist_list = surveylist.filter((geti) => {
				// console.log(geti);
				return geti;
					});
					return surveylist_list;
			},
  },
};
</script>
<style type="text/css" scoped>
.swiper-button-next{
	right:2px !important;
}
.swiper-button-prev{
	left: 2px !important;
}
</style>